<div class="app-content">
  <dispatch-by-job *ngIf="!device.mobile"></dispatch-by-job>
  <mobile-dispatch *ngIf="device.mobile"></mobile-dispatch>
</div>
